import { useI18n as baseUseI18n } from "vue-i18n";
import { i18nOptions } from "../i18n/i18n";

export const useI18n: typeof baseUseI18n = (options) =>
    baseUseI18n({
        ...i18nOptions,
        ...options,
    });
